import { Severity, RequestResult } from "domain/entities/severity";
import { SeverityRepository } from "domain/repositories";

export default class CreateUseCase {
    private severityRepository: SeverityRepository;
    
    public constructor(severityRepository: SeverityRepository) {
        this.severityRepository = severityRepository
    }

    public async createSeverity(severity: Severity, token: Promise<[string | null, string | null]>): Promise<[RequestResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.severityRepository.createSeverity(severity, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}